import React from 'react';
import { PropTypes } from 'prop-types';

import ServicesSlide from '../ServicesSlide';
import ServicesMenu from './ServicesMenu';

import CarouselNavigationButtons from '../CarouselNavigationButtons';

const ServicesContent = ({ styles, slides, width, activeIndex, moveToSlideId, title, titleAs, subtitleAs }) => {
    return (
        <>
            <ServicesMenu
                moveToSlideId={moveToSlideId}
                slides={slides}
                activeIndex={activeIndex}
                title={title}
                titleAs={titleAs}
            />

            <div className={styles.container}>
                {slides.map(slide => (
                    <ServicesSlide
                        key={slide.id}
                        width={width}
                        title={slide.title}
                        description={slide.description}
                        list={slide.list}
                        titleAs={subtitleAs}
                        image={slide?.image}
                        slideId={slide.id}
                    />
                ))}
            </div>

            <CarouselNavigationButtons
                {...{
                    moveToSlideId,
                    activeIndex,
                }}
            />
        </>
    );
};

ServicesContent.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    width: PropTypes.number.isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToSlideId: PropTypes.func.isRequired,
    title: PropTypes.node,
    titleAs: PropTypes.string,
    subtitleAs: PropTypes.string,
};

ServicesContent.defaultProps = {
    title: '',
    titleAs: undefined,
    subtitleAs: undefined,
};

export default ServicesContent;
